/* eslint-disable no-useless-escape */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, } from "@mui/material";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { loadingAction } from "ReduxReducers/loadingReducer";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { gapi } from "gapi-script";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import MuiPhoneNumber from "material-ui-phone-number";
import { useEffect, useState } from "react";
import GoogleLogin from "react-google-login";
import OtpInput from "react-otp-input";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { FacebookLoginButton } from "react-social-login-buttons";
import { LoginSocialFacebook } from "reactjs-social-login";
import { changePass, facebookSignin, googleSigin, sendOTPToUser, userResendOTP, validateOTP } from "utils/authApi";
import { showResMsg, validateEmailAddress, validateField, validatePhoneNumber } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import bgImage from "../../../assets/images/download.jpg";
import { Tooltip } from 'react-tooltip'

const errMsg = {
    color: `red`,
    fontSize: `11px`,
};

function BuSignUp({ ...props }) {
    const navigate = useNavigate();
    const [emailErr, setemailErr] = useState(false);
    const [phoneNumberErr, setPhoneNumberErr] = useState(false);
    const [firstNameTitleErr, setFirstNameTitleErr] = useState("");
    const [firstNameErr, setFirstNameErr] = useState(false)
    const [lastNameErr, setLastNameErr] = useState(false)
    const [lastNameTitleErr, setLastNameTitleErr] = useState("");
    const [emailTitleErr, setemailTitleErr] = useState('');
    const [passwordErr, setPasswordErr] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [signup, setSignup] = useState(false);
    const [showOtp, setOtp] = useState(false);
    const [password, setPassword] = useState(false);
    const [emailOTP, setEmailOTP] = useState();
    const [mobileOTP, setMobileOTP] = useState();
    const [confirmPasswordErr, setConfirmPasswordErr] = useState(false);
    const [passwordTitleErr, setPasswordTitleErr] = useState("");
    const [confirmPasswordTitleErr, setConfirmPasswordTitleErr] = useState("");
    const [phonErrMessage, setPhonErrMessage] = useState("")

    const [disabled, setDisabled] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const clienId = "57104194639-bgjpnobq7110lanj41ogd5001ijvjahk.apps.googleusercontent.com"

    gapi.load("client:auth2", () => {
        gapi.client.init({
            clientId: "57104194639-bgjpnobq7110lanj41ogd5001ijvjahk.apps.googleusercontent.com",
            plugin_name: "chat",
        });
    });
    const dispatch = useDispatch();
    const [values, setValues] = useState({
        firstName: "",
        lastName: "",
        phoneNumber: "",
        onlyPhoneNumber: "",
        emailAddress: "",
        userPassword: "",
        confirmPassword: "", newPassword: ''
    });

    let mandateFlag = false;
    useEffect(() => {
        dispatch(loadingAction(false))
    }, [dispatch]);
    const handleChange = (name) => (event) => {
        const newValue = event.target.value;

        // Name fields validation
        if (name === "firstName" || name === "lastName") {
            // Allow only letters and spaces
            if (!/^[a-zA-Z\s]*$/.test(newValue)) return;

            setValues(prev => ({ ...prev, [name]: newValue }));

            const isInvalid = newValue.trim().length < 2;
            const errorMsg = "Please input at least 2 characters";

            if (name === "firstName") {
                setFirstNameErr(isInvalid);
                setFirstNameTitleErr(isInvalid ? errorMsg : "");
            }

            if (name === "lastName") {
                setLastNameErr(isInvalid);
                setLastNameTitleErr(isInvalid ? errorMsg : "");
            }

            return;
        }

        // Other fields
        setValues(prev => ({ ...prev, [name]: newValue }));

        if (name === "emailAddress") setemailErr(false);
        if (name === "newPassword") setPasswordErr(false);
        if (name === "confirmPassword") setConfirmPasswordErr(false);
    };

    // const handleChange = (name) => (event) => {
    //     const newValue = event.target.value;
    //     if (name === "firstName" || name === "lastName") {
    //         if (/^[a-zA-Z\s]*$/.test(newValue)) {
    //             setValues({ ...values, [name]: newValue });

    //             // Real-time validation: only for 2 characters
    //             if (name === "firstName") {
    //                 if (newValue.trim().length < 2) {
    //                     setFirstNameErr(true);
    //                     setFirstNameTitleErr("Please input at least 2 characters");
    //                 } else {
    //                     // Clear error for 0,1 or 3+ characters
    //                     setFirstNameErr(false);
    //                     setFirstNameTitleErr("");
    //                 }
    //             }
    //             if (name === "lastName") {
    //                 if (newValue.trim().length < 2) {
    //                     setLastNameErr(true);
    //                     setLastNameTitleErr("Please input at least 2 characters");
    //                 } else {
    //                     // Clear error for 0,1 or 3+ characters
    //                     setLastNameErr(false);
    //                     setLastNameTitleErr("");
    //                 }
    //             }

    //         } else {
    //             event.preventDefault();
    //         }
    //     } else if (name === "emailAddress") {
    //         setemailErr(false);
    //     }
    //     else if (name === "phoneNumber") {
    //         setPhoneNumberErr(false);
    //     } else {
    //         setValues({ ...values, [name]: newValue });
    //     }
    // };
    async function resendOTP(sendOtpTo) {
        try {
            values.sendOtpTo = sendOtpTo;
            userResendOTP(values, "login/resendOTP", (data) => {
                showResMsg(data.Result_Status ? "OTP sent successfully on " + sendOtpTo : data.Result_Message, 1000, data.Result_Status);
            }, dispatch)
        } catch (error) {
            console.log("Catch in resendOTP==", error);
        }
    };
    const clearErrorStates = () => {
        setFirstNameErr(false);
        setLastNameErr(false);
        setPhoneNumberErr(false);
        setemailErr(false);
    }

    const signUp = async () => {
        try {

            clearErrorStates();

            if (!disabled) {

                // mandateFlag = validateField(values.firstName, setFirstNameErr) || mandateFlag;
                // Validate first name only on submit

                if (!values.firstName || values.firstName.trim() === "") {

                    setFirstNameErr(true);
                    setFirstNameTitleErr("First Name can't be blank");
                    mandateFlag = true;
                }
                else if (values.firstName.trim().length < 2) {

                    setFirstNameErr(true);
                    setFirstNameTitleErr("Please input at least 2 characters");
                    mandateFlag = true;
                } else {
                    setFirstNameErr(false);
                    setFirstNameTitleErr("");
                }
                if (!values.lastName || values.lastName.trim() === "") {

                    setLastNameErr(true);
                    setLastNameTitleErr("Last Name can't be blank");
                    mandateFlag = true;
                }
                else if (values.lastName.trim().length < 2) {

                    setLastNameErr(true);
                    setLastNameTitleErr("Please input at least 2 characters");
                    mandateFlag = true;
                } else {
                    setLastNameErr(false);
                    setLastNameTitleErr("");
                }
                mandateFlag = validateEmailAddress(values.emailAddress, setemailErr, setemailTitleErr) || mandateFlag;
            }
            mandateFlag = validatePhoneNumber(values.onlyPhoneNumber, setPhoneNumberErr, setPhonErrMessage) || mandateFlag;
            if (!validatePhoneNumber(values.onlyPhoneNumber, setPhoneNumberErr, setPhonErrMessage)) {
                values.mobileNumberExist = true;
            }

            if (mandateFlag) {
                return;
            }

            sendOTPToUser(values, (data) => {
                if (data.Result_Status) {
                    setOtp(true);
                    setSignup(false);
                }
                else {
                    sessionStorage.clear("SIGN_DETAILS")
                    showResMsg(data.Result_Message, 2000, data.Result_Status);
                }
            }, dispatch)

        } catch (error) {
            console.log("Catch in  signup user=", error);
        }
    };

    useEffect(() => {
        const session = JSON.parse(sessionStorage.getItem("SIGN_DETAILS"))
        // console.log("Session Value: ", session)
        if (session !== null) {
            setValues(session)
            setOtp(true)
            setSignup(false)
            setDisabled(true)

        } else {
            setSignup(true)
        }

    }, [])


    const onSuccess = async (res) => {
        const idToken = res.profileObj;

        googleSigin(idToken, (data) => {
            if (data.Result_Status) {
                sessionStorage.setItem("SIGN_DETAILS", JSON.stringify(data.Result_Output))
                setValues(data.Result_Output)
                setDisabled(true)
            }
        }, dispatch);

    };



    async function handleSubmit() {
        try {
            let mandateFlag = false;
            let errorMsg = "";

            if (values.verificationStatus === undefined || values.verificationStatus !== 1) {
                console.log(values.emailOTP);
                if (!values.emailOTP) {
                    errorMsg = "Email OTP can't be blank"; mandateFlag = true;
                }
                // if (!values.mobileOTP && !values.emailOTP) {
                //     errorMsg = "Email and Mobile OTP can't be blank"; mandateFlag = true;
                // }
                else {
                    if (!values.emailOTP) { errorMsg = "Email OTP can't be blank"; mandateFlag = true; }
                    else if (values.emailOTP.length < 6) {
                        errorMsg = "Please enter a valid 6-digit Email OTP"; mandateFlag = true
                    }
                    // else if (!values.mobileOTP) { errorMsg = "Mobile OTP can't be blank"; mandateFlag = true; }
                    // else if (values.mobileOTP.length < 6) {
                    //     errorMsg = "Please enter a valid 6-digit Mobile OTP"; mandateFlag = true
                    // }
                }
            }
            // else {
            //     if (!values.mobileOTP) { errorMsg = "Mobile OTP can't be blank"; mandateFlag = true; }
            //     else if (values.mobileOTP.length < 6) {
            //         errorMsg = "Please enter a valid 6-digit Mobile OTP"; mandateFlag = true
            //     }
            // }

            if (mandateFlag) {
                showResMsg(errorMsg, 2000, false)
                return;
            }
            // console.log("Submit", values);

            validateOTP(values, "login/validateOTP", (data) => {
                if (data.Result_Status) {
                    sessionStorage.clear();
                    showResMsg("OTP Verified Successfully!", 1000, true)
                    setTimeout(() => {
                        setOtp(false)
                        setSignup(false)
                        setPassword(true)
                    }, 1000);

                }
                else {
                    showResMsg(data.Result_Message, 1000, data.Result_Status);
                }
            }, dispatch)

        } catch (error) {
            console.log("Catch in handleSubmit==", error);
        }
    };

    const onFailure = (res) => {
        console.log("dsdasdas", res);
    };

    const handleFacebookResponse = async (response) => {
        if (response.data.accessToken) {
            facebookSignin(response.data, (data) => {
                if (data.Result_Status) {
                    sessionStorage.setItem("SIGN_DETAILS", JSON.stringify(data.Result_Output))
                    setValues(data.Result_Output)
                    setDisabled(true)
                }
            }, dispatch)

        } else {
            showResMsg("Authnication Failed", 1000, false)
        }
    };
    const setPhoneValues = (phone, country) => {
        const dialCode = country.dialCode;

        // Remove country code safely
        const onlyNumber = phone.replace(`+${dialCode}`, "").trim();

        setValues(prev => ({
            ...prev,
            phoneNumber: phone,
            onlyPhoneNumber: onlyNumber,
            countryCode: `+${dialCode}`
        }));

        // Clear error once user starts typing
        if (onlyNumber.length > 0) {
            setPhoneNumberErr(false);

        }
    };

    // const setPhoneValues = (phone, country) => {
    //     values.onlyPhoneNumber = phone.toString().slice(country.dialCode.length + 1).trim();

    //     // Remove country code safely
    //     const onlyNumber = phone.replace(`+${dialCode}`, "").trim();
    //     values.phoneNumber = phone;
    //     values.countryCode = "+" + country.dialCode;
    //     if (onlyNumber.length > 0) {
    //         setPhoneNumberErr(false);

    //     }
    // };


    const handleEmailOTP = val => {
        setEmailOTP(val);
        values.emailOTP = val;
    };

    const handleMobileOTP = val => {
        setMobileOTP(val);
        values.mobileOTP = val;

    };


    const changeUserPass = async () => {
        let mandateFlag = false;
        if (values.newPassword.toString().trim() === "") {
            setPasswordErr(true);
            setPasswordTitleErr("New Password can't be blank")
            mandateFlag = true;
        }
        // else if (values.newPassword.toString().trim().length < 8) {
        //     setPasswordErr(true);
        //     setPasswordTitleErr("New Password should contain atleast 8 characters")
        //     mandateFlag = true;
        // } 
        else if (values.newPassword.toString().trim().length < 8 || values.newPassword.toString().trim().length > 20) {
            setPasswordErr(true);
            setPasswordTitleErr("Password should be between 8 to 20 characters");
            mandateFlag = true;
        } else if (!/[A-Z]/.test(values.newPassword)) {
            setPasswordErr(true);
            setPasswordTitleErr("Password should contain at least one uppercase letter");
            mandateFlag = true;
        } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(values.newPassword)) {
            setPasswordErr(true);
            setPasswordTitleErr("Password should contain at least one special character");
            mandateFlag = true;
        }
        else {
            setPasswordErr(false);
        }
        if (values.confirmPassword.toString().trim() === "") {
            setConfirmPasswordErr(true);
            setConfirmPasswordTitleErr("Confirm Password can't be blank")
            mandateFlag = true;
        }
        //  else if (values.confirmPassword.toString().trim().length < 8) {
        //     setConfirmPasswordErr(true);
        //     setConfirmPasswordTitleErr("Confirm Password should contain atleast 8 characters")
        //     mandateFlag = true;
        // } 
        else if (values.confirmPassword.toString().trim().length < 8 || values.confirmPassword.toString().trim().length > 20) {
            setConfirmPasswordErr(true);
            setConfirmPasswordTitleErr("Password should be between 8 to 20 characters");
            mandateFlag = true;
        } else if (!/[A-Z]/.test(values.confirmPassword)) {
            setConfirmPasswordErr(true);
            setConfirmPasswordTitleErr("Password should contain at least one uppercase letter");
            mandateFlag = true;
        } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(values.confirmPassword)) {
            setConfirmPasswordErr(true);
            setConfirmPasswordTitleErr("Password should contain at least one special character");
            mandateFlag = true;
        } else {
            setConfirmPasswordErr(false);
        }
        if (mandateFlag) {
            return;
        }
        if (values.newPassword.toString().trim() !== values.confirmPassword.toString().trim()) {
            showResMsg(genericMessage.samePassword, 1000, false)
        } else {

            changePass(values, async (data) => {
                if (data.Result_Status) {
                    showResMsg(genericMessage.updated, 2000, true);
                    navigate(`/wizard/${data.Result_Output._id}`);
                } else {
                    showResMsg(data.Result_Message, 2000, false);
                }
            }, dispatch)
        }
    }
    const conditions = [
        {
            test: values.newPassword.trim().length > 8 && values.newPassword.trim().length < 20,
            message: "Password length should be between 8 to 20",
        },
        {
            test: /[A-Z]/.test(values.newPassword),
            message: "Atleast 1 Upper case ",
        },
        {
            test: /[!@#$%^&*(),.?":{}|<>]/.test(values.newPassword),
            message: "Atleast 1 special character",
        },
    ];
    const conditions2 = [
        {
            test: values.confirmPassword.trim().length > 8 && values.confirmPassword.trim().length < 20,
            message: "Password length should be between 8 to 20",
        },
        {
            test: /[A-Z]/.test(values.confirmPassword),
            message: "Atleast 1 Upper case ",
        },
        {
            test: /[!@#$%^&*(),.?":{}|<>]/.test(values.confirmPassword),
            message: "Atleast 1 special character",
        },
    ];
    return (
        <BasicLayout image={bgImage}>
            <Card sx={{ width: 400 }}>
                <MDBox
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                    mx={2}
                    mt={-3}
                    p={2}
                    // mb={1}
                    textAlign="center"
                >
                    <MDTypography variant="h4" fontWeight="medium" color="white" mt={3}>
                        <p style={{ fontWeight: "bold", fontSize: "2rem" }}> Invoice & Recover </p>
                    </MDTypography>
                    <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>

                        <p style={{ fontWeight: "bold", fontSize: "1.5rem" }}>Signup  </p>

                    </MDTypography>
                    <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                        <p style={{ fontWeight: "bold", fontSize: "1.5rem" }}> {showOtp && <>(OTP Verification)</>} {password && <>(Configure Password) </>} </p>
                    </MDTypography>
                    <Grid container spacing={3} justifyContent="center" sx={{ mt: 1, mb: 2 }}>
                    </Grid>
                </MDBox>

                {signup &&
                    <>

                        <MDBox pt={4} pb={3} px={3}>
                            <MDBox component="form" role="form">

                                <MDBox >

                                    <Grid container
                                        columnSpacing={1}
                                        alignItems="center"
                                        display="flex"
                                        justifyContent="center"
                                        spacing={4}
                                    >
                                        {/* <Grid item lg={6} className="socialMedia">
                                            <GoogleLogin
                                                clientId={clienId}
                                                buttonText="Signup with Google"
                                                onSuccess={onSuccess}
                                                onFailure={onFailure}
                                                cookiePolicy={"single_host_origin"}
                                                style={{ width: "130px !important", marginTop: "100px", background: "#1777f2" }}

                                            />
                                        </Grid>
                                        <Grid item lg={6}>
                                            <LoginSocialFacebook
                                                appId={625280223029535}
                                                onResolve={handleFacebookResponse}
                                                onReject={handleFacebookResponse}
                                            >
                                                <FacebookLoginButton text="Signup with Facebook" style={{ background: "#1777f2", fontSize: "12px", height: "44px", width: "165px", fontWeight: "bold", fontFamily: "'Roboto', sans-serif" }} />
                                            </LoginSocialFacebook>

                                        </Grid> */}
                                    </Grid>
                                    {/* <div className="or">
                                        <hr />
                                        <p className="mb-0 orText">or</p>
                                    </div> */}
                                </MDBox>
                                <MDBox mb={2} mt={2}>
                                    <MDInput
                                        type="text"
                                        label="First Name"
                                        fullWidth
                                        disabled={disabled}
                                        value={values.firstName}
                                        autoFocus={true}
                                        inputProps={{
                                            maxLength: 25,
                                            pattern: "[a-zA-Z]*" // Allow only letters and spaces
                                        }}
                                        onChange={handleChange("firstName")}
                                    />
                                    {/* {firstNameErr ? <p style={errMsg}>First Name can't be blank</p> : ""} */}
                                    {firstNameErr ? <p style={errMsg}>{firstNameTitleErr}</p> : ""}
                                </MDBox>
                                <MDBox mb={2}>
                                    <MDInput
                                        type="text"
                                        label="Last Name"
                                        fullWidth
                                        value={values.lastName}
                                        disabled={disabled}
                                        inputProps={{
                                            maxLength: 25
                                        }}
                                        onChange={handleChange("lastName")}
                                    />
                                    {lastNameErr ? <p style={errMsg}>{lastNameTitleErr}</p> : ""}

                                </MDBox>
                                <MDBox mb={2}>
                                    <MDInput
                                        type="email"
                                        label="Email Address"
                                        id="emailInput" name="email"
                                        fullWidth
                                        value={values.emailAddress}
                                        disabled={disabled}
                                        inputProps={{
                                            maxLength: 50
                                        }}
                                        onChange={handleChange("emailAddress")}
                                    />
                                    {emailErr ? <span style={errMsg}> {emailTitleErr}</span> : ""}
                                </MDBox>
                                <MDBox mb={2}>
                                    <MuiPhoneNumber
                                        onlyCountries={["in", "au"]}
                                        defaultCountry={"au"}
                                        type="tel" name="phone_number"
                                        label="Mobile Number"
                                        variant="outlined"
                                        fullWidth
                                        value={values.phoneNumber}
                                        onChange={(phone, country) => setPhoneValues(phone, country)}
                                    />
                                    {phoneNumberErr ? <span style={errMsg}> {phonErrMessage}</span> : ""}
                                </MDBox>
                                <MDBox mb={1}><MDButton variant="gradient" style={{ fontSize: "14px" }} color="info" fullWidth onClick={signUp} >Signup</MDButton></MDBox>
                                <MDBox mb={1} textAlign="center">
                                    <MDTypography variant="button" color="text">
                                        Do have an account?{" "}
                                        <Link to="/login">
                                            <MDTypography variant="button" color="info" fontWeight="medium" textGradient>LogIn</MDTypography>
                                        </Link>
                                    </MDTypography>
                                </MDBox>
                            </MDBox>
                        </MDBox>
                    </>}

                {showOtp &&
                    <Grid container p={1.5}>
                        {values.verificationStatus !== 1 &&
                            <>
                                <Grid container alignItems="center">
                                    <Grid item xs={12} lg={12} px={2.2} style={{ textAlign: "left" }}>
                                        <MDTypography display="block" variant="button" color="black" my={1}>
                                            Please enter OTP sent to {values.emailAddress}
                                        </MDTypography>
                                    </Grid>
                                    <Grid item xs={12} lg={12} style={{ display: "flex", justifyContent: "center" }}>
                                        <OtpInput
                                            shouldAutoFocus={true}
                                            inputStyle="otp-input-style"
                                            numInputs={6}
                                            separator={<span></span>}
                                            value={emailOTP}
                                            onChange={handleEmailOTP}
                                            isInputNum
                                            inputType={'tel'}
                                            renderInput={(props) => <input {...props} style={{ width: "2em" }} />} />
                                        <MDTypography pl={2}
                                            component="a"
                                            onClick={() => resendOTP("Email")}
                                            variant="button"
                                            fontWeight="bold"
                                            color="info"
                                            textGradient
                                            style={{ cursor: "pointer", display: "flex", alignItems: "center", fontSize: "12px" }}
                                        >
                                            Resend OTP
                                        </MDTypography>
                                    </Grid>
                                </Grid>
                            </>
                        }

                        {/* <Grid container p={1.5} alignItems="center">
                            <Grid item xs={12} lg={12} style={{ textAlign: "center" }}>
                                <MDTypography display="block" variant="button" color="black" my={1} mr={6.4}>
                                    Please enter OTP sent to {values.phoneNumber}
                                </MDTypography>
                            </Grid>
                            <Grid item xs={12} lg={12} style={{ display: "flex", justifyContent: "center" }}>
                                <MDBox>
                                    <OtpInput
                                        //  shouldAutoFocus={true} 
                                        inputStyle="otp-input-style" numInputs={6} separator={<span></span>} inputProps={{
                                            pattern: '^[0-9]+$',
                                            maxLength: 6,
                                        }}
                                        value={mobileOTP} onChange={handleMobileOTP} type="text" isInputNum inputType={'tel'} renderInput={(props) => <input {...props} style={{ width: "2em" }} />} />
                                </MDBox>
                                <MDTypography pl={2}
                                    component="a"
                                    onClick={() => resendOTP("Mobile")}
                                    variant="button"
                                    fontWeight="bold"
                                    color="info"
                                    textGradient
                                    style={{ cursor: "pointer", display: "flex", alignItems: "center", fontSize: "12px" }}
                                >
                                    Resend OTP
                                </MDTypography>
                            </Grid>
                        </Grid> */}

                        <Grid container px={1.5} pt={1.5} pb={3} style={{ display: "flex", justifyContent: "center" }}>
                            <Grid item xs={4}>
                                <MDBox>
                                    <MDButton variant="gradient" color="success" fullWidth onClick={handleSubmit} >
                                        Verify
                                    </MDButton>
                                </MDBox>
                            </Grid>
                        </Grid>
                    </Grid>
                }
                {password &&
                    <>

                        <Grid container >
                            <Grid item xs={12} >
                                <MDBox pt={4} px={3}>
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel htmlFor="outlined-adornment-password">New Password</InputLabel>
                                        <OutlinedInput
                                            id="outlined-adornment-password"
                                            type={showPassword ? "text" : "password"}
                                            value={values.newPassword}
                                            inputProps={{
                                                maxLength: 30
                                            }}
                                            // onKeyUp={handleKeyUp}
                                            onKeyUp={(e) => {
                                                if (e.key === "Enter") changeUserPass();
                                            }}
                                            data-tooltip-id="passwordTooltip1"
                                            onChange={handleChange("newPassword")}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        value={values.newPassword}
                                                        onChange={handleChange("newPassword")}
                                                        edge="end"
                                                    >
                                                        {showPassword ? (
                                                            <VisibilityOff onClick={() => setShowPassword(!showPassword)} />
                                                        ) : (
                                                            <Visibility onClick={() => setShowPassword(!showPassword)} />
                                                        )}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                            label="New Password"
                                        />
                                    </FormControl>
                                    <Tooltip id="passwordTooltip1" place="right" effect="solid" border="1px solid #49a3f1" style={{ backgroundColor: 'white', color: 'black', margin: '0px -20px', borderRadius: '5px', }}>
                                        <ol style={{ listStyleType: 'none', padding: 0, margin: 0, fontSize: "12px" }}>
                                            {conditions.map((condition, index) => (
                                                <li key={index} style={{ color: condition.test ? 'green' : 'gray' }}>
                                                    {condition.message}
                                                </li>
                                            ))}
                                        </ol>
                                    </Tooltip>
                                    {passwordErr ? <span style={errMsg}>{passwordTitleErr}</span> : ""}

                                </MDBox>
                                <MDBox pt={4} px={3}>

                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel htmlFor="outlined-adornment-password">Confirm Password</InputLabel>
                                        <OutlinedInput
                                            id="outlined-adornment-password"
                                            type={showConfirmPassword ? "text" : "password"}
                                            value={values.confirmPassword}
                                            inputProps={{
                                                maxLength: 30
                                            }}
                                            onChange={handleChange("confirmPassword")}

                                            onKeyUp={(e) => {
                                                if (e.key === "Enter") changeUserPass();
                                            }}
                                            data-tooltip-id="passwordTooltip"
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        value={values.confirmPassword}
                                                        onChange={handleChange("confirmPassword")}
                                                        edge="end"
                                                    >
                                                        {showConfirmPassword ? (
                                                            <VisibilityOff onClick={() => setShowConfirmPassword(!showConfirmPassword)} />
                                                        ) : (
                                                            <Visibility onClick={() => setShowConfirmPassword(!showConfirmPassword)} />
                                                        )}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                            label="Confirm Password"
                                        />
                                        <Tooltip id="passwordTooltip" place="right" effect="solid" border="1px solid #49a3f1" style={{ backgroundColor: 'white', color: 'black', margin: '0px -20px', borderRadius: '5px', }}>
                                            <ol style={{ listStyleType: 'none', padding: 0, margin: 0, fontSize: "12px" }}>
                                                {conditions2.map((condition, index) => (
                                                    <li key={index} style={{ color: condition.test ? 'green' : 'gray' }}>
                                                        {condition.message}
                                                    </li>
                                                ))}
                                            </ol>
                                        </Tooltip>
                                    </FormControl>
                                    {confirmPasswordErr ? <span style={errMsg}>{confirmPasswordTitleErr}</span> : ""}
                                </MDBox>
                            </Grid>
                        </Grid>

                        <Grid
                            container
                            mt={2}
                            pb={2}
                            px={3}
                            columnSpacing={4}
                            alignItems="center"
                            display="flex"
                            justifyContent="center"
                        >

                            <Grid item xs={12} md={4} spacing={2} lg={6}>
                                <MDButton
                                    rel="noreferrer"
                                    variant="gradient"
                                    className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                                    color="success"
                                    onClick={changeUserPass}
                                    fullWidth

                                >
                                    Proceed
                                </MDButton>
                            </Grid>
                        </Grid>

                    </>

                }


            </Card>
        </BasicLayout>
    );
}

export default BuSignUp;
